import { createContext } from "react";

export type OnboardingState = {
  value: OnboardingValue;
  set: (
    value: OnboardingValue | ((prev: OnboardingValue) => OnboardingValue)
  ) => void;
};

export type OnboardingValue = {
  about: string;
  looking: string[];
  email: string;
  plan: string;
};

export const OnboardingContext = createContext<OnboardingState>({
  value: {} as any,
  set: () => {},
});
